import * as React from "react";
const SquareRatioSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13,4 C13.5522847,4 14,4.44771525 14,5 L14,14 C14,14.5522847 13.5522847,15 13,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,5 C3,4.44771525 3.44771525,4 4,4 L13,4 Z M13,5 L4,5 L4,14 L13,14 L13,5 Z" }));
SquareRatioSmall.displayName = "SquareRatioSmall";
var SquareRatioSmall_default = SquareRatioSmall;
export {
  SquareRatioSmall_default as default
};
